<template>
  <div class="box" style="width: 100%;" >
    <div v-if="step === 'select'" style="width: 100%;">
      <h2>Review Your Selections</h2>

      <div class="m-slide-section">
        <h4>Step 1 : Select Target Areas(s)</h4>
        <m-slide-item :items="geos" :deleteFun="deleteGeo" data-test="slide-order-geo"/>
      </div>

      <div class="m-slide-section">
        <h4>Step 2 : Define Target Audience(s)</h4>
        <m-slide-item :items="demos" :deleteFun="deleteDemo" data-test="slide-order-demo"/>
      </div>
      <div style="display: flex; justify-content: center">
        <b-link v-b-modal.modal1 class="reset-order" >Reset Order</b-link>
      </div>
    </div>
    <div v-if = "step === 'summary'" style="width: 100%;">
      <m-slide-summary />
    </div>
    <b-modal id="modal1" @ok="resetOrder" title="Confirm">
      <p class="my-4">Are you sure you want to reset your order?
      </p>
    </b-modal>
  </div>
</template>

<script>
  import MSlideSummary from '@/components/slide/MSlideSummary.vue'
  import MSlideItem from '@/components/slide/MSlideItem.vue'
  import notification from '@/components/common/notification'

  export default {
    components: {
      MSlideSummary,
      MSlideItem
    },
    computed: {
      step () {
        if (this.$route.name === 'summary' || this.$route.name === 'success') {
          return 'summary'
        } else {
          return 'select'
        }
      },
      demos () {
        return this.$store.getters['order/demos']
      },
      geos () {
        return this.$store.getters['order/geos']
      }
    },
    methods: {
      deleteGeo (item) {
        this.$store.commit('order/deleteGeo', item.GeoKeyCode)
      },
      deleteDemo (item) {
        if (item.hasOwnProperty('is50')) {
          if (item.key === 'target') {
            let targetoption = this.$store.getters['order/targetOption']
            this.$store.commit('order/saveKey', ['TargetOption', targetoption - item.value])
            this.$store.commit('demo/removeoption', {key: 'target', val: item.value})
          } else {
            let targetoption = this.$store.getters['order/routeOption']
            this.$store.commit('order/saveKey', ['RouteOption', targetoption - item.value])
            this.$store.commit('demo/removeoption', {key: 'route', val: item.value})
          }
        } else {
          this.$store.dispatch('order/deleteDemo', {
            type: 'value',
            attributeValue: item.AttributeValue,
            columnName: item.ColumnName,
            name: item.AttributeValueName,
            demoCategoryType: item.DemoCategoryType
          })
        }
      },
      resetOrder () {
        this.$store.dispatch('order/initOrder', parseInt(this.$route.params.listType))
        notification.notice('success', 'Order has been reset')
      }
    }
  }
</script>
<style scoped lang="scss">
  .sub-title {
    color: $color-text-grey;
    font-size: $size-normal;
    font-weight: normal;
    margin-bottom: 1em;
  }
  .reset-order {
    margin-top: 24px;
    color: #999;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/slide/MSlide.vue